<template>
  <div class="l-row">
    <form-group label="" :columns="5">
      <input class="form-select" :value="announcementVariationName" readonly="readonly">
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group label="" :columns="6">
      <select class="form-select" v-model="announcementVariation.sku" :disabled="disabledInput">
        <option :value=null>{{ $t('no.migration.label') }}</option>
        <option v-for="productVariation in productVariations" :key="productVariation" :value="productVariation.sku">
          {{ productVariationName(productVariation) }}
        </option>
      </select>
    </form-group>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      migration: {
        type: Object,
        required: true
      },
      announcementVariation: {
        type: Object,
        required: true
      },
      productVariations: {
        type: Array,
        required: true
      },
      announcementHasOnlyOneVariation: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      let skuExists = this.productVariations.find(variation => variation.sku === this.announcementVariation.sku)

      if (!skuExists) {
        this.announcementVariation.sku = null
      }

      if (this.announcementHasOnlyOneVariation && this.productVariations.length === 1) {
        this.announcementVariation.sku = this.productVariations[0].sku
      }
    },
    methods: {
      productVariationName (variation) {
        let name = []

        if (variation.sku) {
          name.push(`SKU: ${variation.sku}`)
        }

        if (variation.ean) {
          name.push(`EAN: ${variation.ean}`)
        }

        if (variation.gender) {
          name.push(`Gênero: ${this.$t(`gender.${variation.gender}.label`)}`)
        }

        if (variation.attributes.color) {
          name.push(`Cor: ${variation.attributes.color}`)
        }

        if (variation.attributes.size) {
          name.push(`Tamanho: ${variation.attributes.size}`)
        }

        return name.join(' - ')
      }
    },
    computed: {
      announcementVariationName () {
        const name = this.announcementVariation.attributes.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            return -1
          }
          if (a.name.toLowerCase() > b.name.toLowerCase()) {
            return 1
          }
          return 0
        }).map(attribute => (attribute.name + ': ' + attribute.value_name))

        return name.join(' - ')
      },
      disabledInput () {
        if (this.migration.variations.indexOf(this.announcementVariation.code) !== -1) {
          return true
        }

        return false
      }
    },
    components: {
      FormGroup
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: -10px auto 0

  .vertical-center
    display: flex
    align-items: center
    min-height: 51px
</style>



// WEBPACK FOOTER //
// WithVariation.vue?4da6a9db